import $http from '@/api';

/**
 * Gets an image resource
 * @param {string} url - The image url.
 * @return {Blob}
 */
const getImageBlob = url => $http.get(`/api/proxy?url=${encodeURI(url)}`, { responseType: 'blob' });

export default {
  getImageBlob,
};
